import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { hideFilterOverlay } from "../../../state/modules/layout/actions";
import { analyticsRefinementsCloseMobile } from "../../../state/modules/analytics/actions";
import styles from "./index.css";

export const RefinementListCloseButton = ({ formatTranslation, onClick }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    onClick && onClick();
    dispatch(hideFilterOverlay());
    dispatch(analyticsRefinementsCloseMobile());
  };

  return (
    <button
      className={styles.refinementListCloseButton}
      onClick={handleClick}
      aria-label={formatTranslation("accessibility_label_close")}
    />
  );
};

RefinementListCloseButton.propTypes = {
  hideFilterOverlay: PropTypes.func.isRequired,
  analyticsRefinementsCloseMobile: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  onClick: PropTypes.func
};

RefinementListCloseButton.displayName = "RefinementListCloseButton";

export default RefinementListCloseButton;
